import useEventCallback from '../../../hooks/useEventCallback'
import {useSetUserProperty} from '../../../hooks/useSetUserProperty'
import {useBooleanUserProperty} from '../../../hooks/useUserProperty'

export function useNewFeatureProperty(userPropertyName: string) {
  const isFeatureSeen = useBooleanUserProperty(userPropertyName, false)

  const setUserProperty = useSetUserProperty()
  const setFeatureAsSeen = useEventCallback(() => {
    if (!isFeatureSeen) {
      setUserProperty(userPropertyName, 'true')
    }
  })

  return [isFeatureSeen, setFeatureAsSeen] as const
}
